/* elemé — real cart-drawer opener, used by the perfume PDP's Add to Bag buttons.
 * Found by reading assets/cart-drawer.js directly: the <cart-drawer> custom element has a
 * public renderContents(parsedState, isClosedCart) method that BOTH re-renders the drawer's
 * live content (via Shopify's Section Rendering API) AND opens it, matching exactly what the
 * theme's own native add-to-cart flow does. Clicking the cart icon programmatically doesn't
 * do this — that only toggles open/closed with whatever content is already in the DOM (stale).
 * This calls the theme's own real method with the exact data shape it expects, instead of a
 * synthetic click that doesn't trigger the render-then-open sequence. */
window.elemeOpenCartDrawer = window.elemeOpenCartDrawer || function () {
  var drawerEl = document.querySelector('cart-drawer');
  if (!drawerEl || typeof drawerEl.renderContents !== 'function') {
    // No drawer on this theme setup (cart_type: page) — fall back to the cart page.
    window.location.href = '/cart';
    return Promise.resolve();
  }
  return fetch('/?sections=cart-drawer,cart-icon-bubble')
    .then(function (r) { return r.json(); })
    .then(function (sections) {
      drawerEl.renderContents({ sections: sections }, true);
    })
    .catch(function () {
      window.location.href = '/cart';
    });
};
